export enum UserResponseCreateOrgError {
  unableToCreateOrg = 'unableToCreateOrg',
}
